module.exports = __webpack_public_path__ + "img/xiangmu_03.f860d851.jpg";